module.exports = {
      id: "telephone-usage",
      viewBox: "0 0 19.1 19.1",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#telephone-usage",
      toString: function () {
        return this.url;
      }
    }